import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'
import SectionHeading from '@/components/landing/section-heading'
import { ACCENT_STYLES, FEATURES } from '@/constants/landing'

const FeaturesSection: FC = (): ReactNode => {
    return (
        <section id='features' aria-labelledby='features-title' className='relative scroll-mt-20 py-24 sm:py-32'>
            <div className='mx-auto max-w-7xl px-5 sm:px-8'>
                <SectionHeading
                    id='features-title'
                    eyebrow='Why Neon Gambit'
                    title={<>Everything you need to play your best. <span className='text-muted-foreground'>Nothing that gets in the way.</span></>}
                    description="Built by players who live for the late-night blitz session: fast pairing, honest ratings and review tools that actually make you better."
                />

                <ul className='mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3'>
                    {FEATURES.map(feature => {
                        const accent = ACCENT_STYLES[feature.accent]
                        const Icon = feature.icon

                        return (
                            <li
                                key={feature.title}
                                className={cn(
                                    'group relative overflow-hidden rounded-3xl border border-white/10 bg-card/60 p-7 transition-all duration-300 hover:-translate-y-1',
                                    accent.hoverBorder
                                )}
                            >
                                <div
                                    aria-hidden='true'
                                    className='pointer-events-none absolute -right-12 -top-12 size-40 rounded-full opacity-0 blur-3xl transition-opacity duration-500 group-hover:opacity-40'
                                    style={{ backgroundColor: accent.hex }}
                                />

                                <span className={cn('flex size-12 items-center justify-center rounded-2xl border', accent.border, accent.bg)}>
                                    <Icon className={cn('size-6', accent.text)} style={{ filter: `drop-shadow(0 0 6px ${accent.hex})` }} />
                                </span>

                                <h3 className='mt-6 font-heading text-lg font-semibold tracking-tight'>
                                    {feature.title}
                                </h3>

                                <p className='mt-3 text-sm leading-relaxed text-muted-foreground'>
                                    {feature.description}
                                </p>
                            </li>
                        )
                    })}
                </ul>
            </div>
        </section>
    )
}

export default FeaturesSection
